export function getFileNameFromUrl(url: string) {
    if(!url) return '';
    return url.substring(url.lastIndexOf('/') + 1);
}